import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy">
      <h1 className="privacyTopic">Privacy Policy</h1>
      <ul className="contentPoli">
        <li className="subTopic">Introduction :</li>
        <p className="content">
          This privacy policy explains how Janux Academy ("we", "us", "our")
          collects, uses, and discloses information from users who download and
          use our mobile application on Google Play Store ("Application"). We
          take your privacy seriously and aim to be transparent about our data
          collection practices. By using our Application, you agree to the terms
          of this Privacy Policy.
        </p>
        <li className="subTopic">Data Collection :</li>
        <p className="content">
          When you register for our Application, we collect your email,
          password, first name, and last name. This information is necessary for
          us to create and maintain your account, provide you with access to our
          courses, and personalize your experience within the Application.
        </p>
        <p className="content">
          We do not collect or request access to your storage or location data.
          However, we do require internet access permission to provide you with
          uninterrupted access to our courses.
        </p>
        <li className="subTopic">Usage of Collected Data :</li>
        <p className="content">
          We use the collected data to personalize your experience within the
          Application, provide you with access to our courses, and improve our
          services. We may also use your email to send you promotional offers
          and updates about our courses. However, you may opt-out of these
          emails at any time by using the unsubscribe link in the email.
        </p>
        <li className="subTopic">Disclosure of Collected Data :</li>
        <p className="content">
          We may disclose your information to our service providers who assist
          us in providing our services to you. We may also disclose your
          information in response to a court order, subpoena, or other legal
          process.
        </p>
        <li className="subTopic">Data Security :</li>
        <p className="content">
          We take reasonable measures to protect your data from unauthorized
          access or disclosure. However, please note that no method of
          transmission over the internet or electronic storage is 100% secure.
        </p>
        <li className="subTopic">Data Retention :</li>
        <p className="content">
          We retain your data for as long as necessary to provide you with
          access to our courses and improve our services. If you wish to delete
          your account, please contact us at the email address provided below.
        </p>
        <li className="subTopic">Updates to this Privacy Policy:</li>
        <p className="content">
          We may update this Privacy Policy from time to time. We will notify
          you of any material changes by posting the new Privacy Policy on our
          website or within the Application.
        </p>
        <li className="subTopic">Contact Us :</li>
        <p className="content">
          If you have any questions or concerns about this Privacy Policy or our
          data collection practices, please contact us at
          Januxacademy98@gmail.com.
        </p>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
